<template>                    
    
    <v-layout row>
        <v-flex xs12>
            <v-select                        
                label="Auswahl Client"                                
                dark              
                cache-items
                required
                v-bind:items="ccClients"     
                item-text="name"
                item-value="id"
                return-object
                v-model="ccClient"></v-select>
        </v-flex>
        <
    </v-layout>
       

</template>

<script>

export default {
    
    
    data() {
        
        return {           
            
            
        };
    },
    
    /*created: function(){
        this.$store.dispatch('setTypes')
    },*/
    computed: {
       
       
        loading: function() {
            return this.$store.getters.loading
        },
        
    },
    methods: {
        
              
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// clientsSelectSingle.vue?3ba5b164